import PropTypes from 'prop-types';

const propTypes = {
  lang: PropTypes.string,
  style: PropTypes.string,
  currency: PropTypes.string,
  integerOnly: PropTypes.bool,
};

const defaultProps = {
  lang: 'fr',
  style: 'currency',
  currency: 'EUR',
  integerOnly: false,
};

/**
 * Display formatted price (choose lang and currency)
 * @param {Object} props Component pros
 * @returns {number} Formatted price
 */
const PriceFormatter = props => {
  const intlConfig = {
    style: props.style,
    currency: props.currency,
    notation: props.notation,
    compactDisplay: props.compactDisplay,
  };

  if (props.integerOnly === true) {
    intlConfig.minimumFractionDigits = 0;
    intlConfig.maximumFractionDigits = 0;
  }

  const formatPrice = price => {
    return new Intl.NumberFormat(props.lang, intlConfig).format(price);
  };

  return formatPrice(props.children);
};

PriceFormatter.propTypes = propTypes;
PriceFormatter.defaultProps = defaultProps;
export default PriceFormatter;
